module.exports = __webpack_public_path__ + "static/assets/9eb55063ba77122ff9de49caf05ca39f.gif";